<div class="step" [ngClass]="{'selected': (currentStep ?? 1) >= (step ?? 0)}"></div>